'use client';

// src/app/(public)/layout.tsx
// ============================================================================
// PUBLIC ROUTE GROUP LAYOUT
// Wraps all public pages: Home, About, Sign In
// Features: Sticky header with Navigation component
// Theme: Fully locked to /src/lib/theme
// ============================================================================

import React from 'react';
import { theme } from '@/lib/theme';
import { Navigation } from '@/components/ui/Navigation';

interface PublicLayoutProps {
  children: React.ReactNode;
}

export default function PublicLayout({ children }: PublicLayoutProps) {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        minHeight: '100vh',
        backgroundColor: theme.colors.paper,
        color: theme.colors.ink,
      }}
    >
      {/* Sticky Header */}
      <Navigation />

      {/* Main Content Area */}
      <main
        style={{
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        {children}
      </main>

      {/* Optional Footer (stub for future) */}
      <footer
        style={{
          borderTop: `1px solid rgba(198, 161, 74, ${theme.tokens.opacity.goldDefault})`,
          padding: `${theme.tokens.spacing[6]} ${theme.tokens.spacing[4]}`,
          backgroundColor: theme.colors.paper,
          color: theme.colors.muted,
          textAlign: 'center',
          fontSize: theme.typography.sizes.sm,
        }}
      >
        <p style={{ margin: 0 }}>
          © 2025 The Deck Compass. A sacred space for reading and reflection.
        </p>
      </footer>
    </div>
  );
}